import React, { useEffect, useState, useReducer, Fragment } from 'react';
import './style.scss';
import language from '@language';
import { addFields, loadFields } from '@helpers/smart-fields-helper';
import cl from 'classnames';
import { reducer, initialState } from './reducer';
import Loader from '@ui-components/loader';
import NumberFormat from 'react-number-format';
import PaymentCardMessage from '../payment-card-message';

const PaymentCard = (props) => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const [fieldsBrand, setFieldsBrand] = useState(false);
    const [showValidations, setShowValidations] = useState({ name: false });
    const [isEditing, setIsEditing] = useState({ name: false });
    const [isSmartFieldLoading, setIsSmartFieldLoading] = useState(true);

    const setEmpty = (field, value) => {
        dispatch({ type: 'set-empty', payload: { field, value } });
    };

    const setComplete = (field, value) => {
        dispatch({ type: 'set-complete', payload: { field, value } });
    };

    const setErrors = (field, value) => {
        dispatch({ type: 'set-errors', payload: { field, value } });
    };

    const setDlocalInstance = dlocalInstance => {
        dispatch({ type: 'set-dlocal-instance', payload: dlocalInstance });
    };

    const setFields = (field, value) => {
        dispatch({ type: 'set-fields', payload: { field, value } });
    };

    useEffect(() => {
        const smartFieldsConfig = window.smartFieldsConfig;
        addFields(() => loadFields(smartFieldsConfig, false, setDlocalInstance, setFields, setIsSmartFieldLoading, setEmpty, setComplete, setErrors, setFieldsBrand, props.country), smartFieldsConfig);
    }, []);

    const handleSubmit = event => {
        event.preventDefault();
        let hasErrors = state.errors.pan || state.errors.expiration || state.errors.cvv || props.validate();

        if (state.empty.pan) {
            setErrors('pan', state.empty.pan);
            hasErrors = true;
        }
        if (state.empty.expiration) {
            setErrors('expiration', state.empty.expiration);
            hasErrors = true;
        }
        if (state.empty.cvv) {
            setErrors('cvv', state.empty.cvv);
            hasErrors = true;
        }

        if (hasErrors || (!fieldsBrand && state.errors.pan) || !state.complete.expiration || !state.complete.cvv) {
            return;
        }

        props.setLoading(true);
        state.dlocalInstance
            .createToken(state.fields.pan, {
                name: props.fieldsValues.name
            })
            .then(response => {
                const token = response.token;
                props.onSubmit(token);
            })
            .catch(_ => {
                props.setLoading(false);
                //document.getElementById('genericError').classList.remove('hidden');
            });
    };

    const handleChange = event => {
        event.preventDefault();
        const { name, value } = event.target;
        const { fieldsValues } = props;
        const newFields = { ...fieldsValues, [name]: value };
        let newShowValidations = { ...showValidations, [name]: true };
        setShowValidations(newShowValidations);
        props.onChange(newFields);
    };

    const handleFocus = (event, focus) => {
        const { name } = event.target;
        let newIsEditing = { name: false };
        newIsEditing[name] = focus;
        setIsEditing(newIsEditing);
    };

    const reset = event => {
        event.preventDefault();
        var form = document.querySelector('form');
        form.reset();

        state.fields.pan.clear();
        state.fields.cvv.clear();
        state.fields.expiration.clear();

        props.onReset();
    };


    const returnInvoicePage = (e) => {
        e.preventDefault();
        props.returnInvoicePage()
    }

    return (
        <div className="payment-card">
            {(props.isLoading || isSmartFieldLoading) && <Loader color="#fff" isPrincipal={true} />}
            
            <div className={cl('content card shadow', { visible: !props.isLoading, hidden: props.isLoading })}>
                <form id="fields-form" onSubmit={handleSubmit}>
                    <div className="fieldset">
                        {props.success && (
                            <PaymentCardMessage
                                isSuccess={true}
                                message={language.cardPayment.messageSuccess}
                                actions={[
                                    { label: language.cardPayment.returnButton, onClick: returnInvoicePage }
                                ]}
                            />
                        )}

                        {props.errors.rejected && (
                            <PaymentCardMessage
                                isSuccess={false}
                                message={language.cardPayment.messageError}
                                actions={[
                                    { label: language.cardPayment.close, onClick: reset }
                                ]}
                            />
                        )}

                        <Fragment>
                            <legend className="title">{language.cardPayment.title}</legend>
                            <div
                                id="generalErrorContainer"
                                className={cl({
                                    hasError: (props.errors.general)
                                })}>
                                <div className="errorMsgContainer">
                                    <span id="expirationErrorMsg" className="error-tooltip">
                                        {language.cardPayment.errorGeneral}
                                    </span>
                                </div>
                            </div>
                            <fieldset>
                                <div id="fieldNameContainer" className={cl({ hasError: props.errors['name'] && !isEditing.name && showValidations.name })}>
                                    <div className="field input">
                                        <label>{language.cardPayment.name.label}</label>
                                        <input
                                            id="cardholder-name"
                                            type="text"
                                            name="name"
                                            placeholder={language.cardPayment.name.placeholder}
                                            required={true}
                                            onChange={e => handleChange(e)}
                                            onFocus={e => handleFocus(e, true)}
                                            onBlur={e => handleFocus(e, false)}
                                            autoComplete="name"
                                        />
                                    </div>
                                    <div className="errorMsgContainer">
                                        <span id="nameErrorMsg" className="error-tooltip">
                                            {language.cardPayment.name.required}
                                        </span>
                                    </div>
                                </div>
                                <div id="fieldPanContainer" className={cl('mt-sm', { hasError: state.errors.pan })}>
                                    <div className="field input">
                                        <label>{language.cardPayment.pan.label}</label>
                                        <div id="containerPan" className="input-smart-field"></div>
                                    </div>
                                    <div className="errorMsgContainer">
                                        <span id="panErrorMsg" className="error-tooltip">
                                            {state.errors.pan && !state.errors.pan ? language.cardPayment.pan.invalid : language.cardPayment.pan.required}
                                        </span>
                                    </div>
                                </div>
                                <div className="container mt-sm">
                                    <div id="fieldExpirationContainer" className={cl('half', { hasError: state.errors.expiration })}>
                                        <div className="field input">
                                            <label>{language.cardPayment.expiration.label}</label>
                                            <div id="containerExpiration" className="input-smart-field"></div>
                                        </div>
                                        <div className="errorMsgContainer">
                                            <span id="expirationErrorMsg" className="error-tooltip">
                                                {state.errors.expiration && !state.errors.expiration ? language.cardPayment.expiration.invalid : language.cardPayment.expiration.required}
                                            </span>
                                        </div>
                                    </div>
                                    <div id="fieldCVVContainer" className={cl('half', { hasError: state.errors.cvv })}>
                                        <div className="field input">
                                            <label>{language.cardPayment.cvv.label}</label>
                                            {props.showCvvHelper && (
                                                <div className="tooltipContainer">
                                                    <img
                                                        id="cvvTooltip"
                                                        alt="cvv"
                                                        className="tooltipImage"
                                                        src="https://static.dlocal.com/fields/test/assets/cc-input-icon/question.svg"
                                                    />

                                                    <div className="tooltipInner">
                                                        <img className="tooltipInnerImage" src="https://static.dlocal.com/facebook/cvv-help.png" />
                                                    </div>
                                                </div>
                                            )}
                                            <div id="containerCVV" className="input-smart-field"></div>
                                        </div>
                                        <div className="errorMsgContainer">
                                            <span id="cvvErrorMsg" className="error-tooltip">
                                                {state.errors.cvv && !state.errors.cvv ? language.cardPayment.cvv.invalid : language.cardPayment.cvv.required}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <div className="amount">
                                <span>Monto total</span>
                                <NumberFormat
                                    displayType="text"
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix=" $"
                                    value={props.amount} />
                            </div>

                            <div className="actions">
                                <button type="submit" className="primary">
                                    {language.cardPayment.pay}
                                </button>
                            </div>
                        </Fragment>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default PaymentCard;